const CLOCK_LOCALIZATION = {
    LOCAL: 'LOCAL',
    SERVER: 'SERVER'
};
const CLOCK_CONSTS = {
    TIMER_UPDATE_INTERVAL: 1000,
    DEFAULT_CLOCK_UPDATE_FROM_SERVER_INTERVAL: '00:05:00'
};

export {CLOCK_LOCALIZATION, CLOCK_CONSTS};